import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import FadedImage, { fadedStyle } from '~components/FadedImage';
import Hero, { heroImgStyles } from '~components/Hero';
import Panel from '~components/Panel';
import Text, { ConstrainedText } from '~components/Text';

import { roundedImg } from '~theme';

// Page Navigation
import PageNav from '~components/PageNav';
import SupportingEachotherCard from '~components/PageCard/SupportingEachotherCard';
import MyrzahCard from '~components/PageCard/MyrzahCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Notre réponse à la pandémie de COVID-19" desc="Description" />
      <Hero title="Notre réponse à la pandémie de COVID-19">
        <StaticImage style={heroImgStyles} src="../../images/family-video-call.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        La pandémie de COVID-19 a créé plusieurs défis pour la communauté des personnes atteintes du DT1 et a signifié que nous devions trouver de nouvelles façons de poursuivre notre mission et le niveau de service et de soutien attendu de FRDJ.
        </ConstrainedText>
        <ConstrainedText>
        Comme la plupart des entreprises et des organismes sans but lucratif, nous savions que la pandémie aurait des répercussions financières et que nous devrions faire preuve de souplesse et d’agilité pour maintenir nos objectifs de collecte de fonds et nos programmes.
        </ConstrainedText>
      </div>
      <FadedImage
        image={
          <StaticImage
            src="../../images/bag-with-mask.jpg"
            style={fadedStyle}
            alt=""
            layout="fullWidth"
          />
        }
      >
        <Text>
          Nous savions également que pour les 300 000 Canadiens vivant avec le DT1, cela ajoutait une nouvelle contrainte à la gestion quotidienne de la maladie, en particulier lorsque nous avons appris qu’ils étaient plus à risque de subir des conséquences plus importantes s’ils contractaient le virus.
        </Text>
      </FadedImage>
      <div tw="container">
        <Text>
        Une fois que nous avons eu des informations précises et opportunes, nous les avons partagées avec notre communauté. Cela a pris la forme de plusieurs bulletins d’information par courriel, des mises à jour sociales et une section dédiée au DT1 et au COVID-19 sur notre site Web. Nous avons également organisé des événements Facebook en direct avec des experts et lancé notre série « Parlons DT1 », qui comprenait un événement de rentrée des classes pendant la COVID-19, qui fut le plus populaire.
        </Text>
      </div>
      <Panel variant="light">
        <div tw="grid gap-6 items-center lg:(grid-cols-2 gap-48)">
          <div tw="max-w-sm lg:order-2">
            <StaticImage src="../../images/NACI.jpg" alt="" style={roundedImg} />
          </div>
          <div tw="lg:(order-1)">
            <Text tw="text-2xl">
            Lorsque les vaccins ont commencé à être disponibles, nous nous sommes associés à d’autres organisations canadiennes luttant contre le diabète pour plaider auprès du Conseil consultatif national de l’immunisation (CCNI) en faveur d’un accès plus rapide et nous avons créé un modèle que les membres de la communauté peuvent utiliser pour adresser une pétition à leur unité de santé publique locale et aux autorités sanitaires provinciales.
            </Text>
          </div>
        </div>
      </Panel>
      <div tw="container">
        <Text>
        Malgré les défis posés par la COVID-19, nous avons pu soutenir nos engagements envers nos recherches et continuer à remplir notre mission tout au long de la pandémie. Nous avons tiré des enseignements des soins médicaux virtuels et nous les utilisons pour aider nos partenaires à plaider en faveur d’une meilleure couverture des dispositifs de traitement du diabète. Les partenariats que nous avons créés dans le cadre de notre pétition auprès du gouvernement pour un accès plus rapide aux vaccins nous permettront de mieux servir la communauté du DT1. Et nombre de nos événements virtuels se sont poursuivis jusqu’en 2021, ce qui nous a permis de toucher des gens d’un bout à l’autre du pays.
        </Text>
        <PageNav previous={<SupportingEachotherCard />} next={<MyrzahCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
